import { render, staticRenderFns } from "./tabMscBookingInfo.vue?vue&type=template&id=0cf0d409&"
import script from "./tabMscBookingInfo.vue?vue&type=script&lang=js&"
export * from "./tabMscBookingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf0d409')) {
      api.createRecord('0cf0d409', component.options)
    } else {
      api.reload('0cf0d409', component.options)
    }
    module.hot.accept("./tabMscBookingInfo.vue?vue&type=template&id=0cf0d409&", function () {
      api.rerender('0cf0d409', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabMscBookingInfo.vue"
export default component.exports